import { RetrievalQueries } from "@faire/retailer-visitor-shared/features/RetrievalQueries/RetrievalQueries";
import { useCategoryPageAllRetrievalQueries } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageAllRetrievalQueries";
import { useCategoryPageRequestId } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageRequestId";
import React from "react";

export const CategoryPageRetrievalQueries = () => {
  const allRetrievalQueries = useCategoryPageAllRetrievalQueries();
  const requestId = useCategoryPageRequestId();

  return (
    <RetrievalQueries
      allRetrievalQueries={allRetrievalQueries}
      requestId={requestId}
    />
  );
};
